const selector = '[data-intro-with-stats]';
const valueSelector = '.js-intro-with-stats-value';
const duration = 1400;

function getValueParts(value) {
	const match = value.match(/-?\d[\d,]*(?:\.\d+)?/);

	if (!match) {
		return false;
	}

	const numberText = match[0];
	const decimals = numberText.includes('.') ? numberText.split('.')[1].length : 0;
	const number = Number(numberText.replace(/,/g, ''));

	if (!Number.isFinite(number)) {
		return false;
	}

	return {
		decimals: decimals,
		number: number,
		prefix: value.slice(0, match.index),
		suffix: value.slice(match.index + numberText.length),
		useGrouping: numberText.includes(','),
	};
}

function formatValue(parts, value) {
	const formatter = new Intl.NumberFormat('en-US', {
		maximumFractionDigits: parts.decimals,
		minimumFractionDigits: parts.decimals,
		useGrouping: parts.useGrouping,
	});

	return parts.prefix + formatter.format(value) + parts.suffix;
}

function animateValue(element) {
	if (element.dataset.countUpAnimated === 'true') {
		return;
	}

	const finalValue = element.dataset.countUpValue || element.textContent.trim();
	const parts = getValueParts(finalValue);

	if (!parts) {
		return;
	}

	element.dataset.countUpAnimated = 'true';
	element.textContent = formatValue(parts, 0);

	const start = performance.now();

	function update(now) {
		const progress = Math.min((now - start) / duration, 1);
		const easedProgress = 1 - Math.pow(1 - progress, 3);
		const currentValue = parts.number * easedProgress;

		element.textContent = formatValue(parts, currentValue);

		if (progress < 1) {
			requestAnimationFrame(update);
		} else {
			element.textContent = finalValue;
		}
	}

	requestAnimationFrame(update);
}

function animateBlock(block) {
	block.querySelectorAll(valueSelector).forEach(animateValue);
}

function initIntroWithStats() {
	const blocks = document.querySelectorAll(selector);

	if (!blocks.length) {
		return;
	}

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return;
	}

	if (!('IntersectionObserver' in window)) {
		blocks.forEach(animateBlock);
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				animateBlock(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.35,
	});

	blocks.forEach((block) => observer.observe(block));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initIntroWithStats);
} else {
	initIntroWithStats();
}